import React from 'react';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Global Error Boundary caught an error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '2rem',
                    fontFamily: 'system-ui, sans-serif',
                    maxWidth: '800px',
                    margin: '0 auto',
                    color: '#333'
                }}>
                    <h1 style={{ color: '#dc2626' }}>Something went wrong (Application Crash)</h1>
                    <p>The application encountered a critical error and could not render.</p>

                    <div style={{
                        background: '#f3f4f6',
                        padding: '1.5rem',
                        borderRadius: '0.5rem',
                        overflowX: 'auto',
                        marginBottom: '1rem',
                        border: '1px solid #e5e7eb'
                    }}>
                        <h3 style={{ margin: '0 0 1rem', fontSize: '1.1rem' }}>Error Details:</h3>
                        <pre style={{ margin: 0, color: '#dc2626', fontWeight: 'bold' }}>
                            {this.state.error && this.state.error.toString()}
                        </pre>
                    </div>

                    <div style={{ fontSize: '0.9rem', color: '#666' }}>
                        <p><strong>Stack Trace (Component Tree):</strong></p>
                        <pre style={{ background: '#333', color: '#fff', padding: '1rem', borderRadius: '0.5rem', overflow: 'auto' }}>
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </pre>
                    </div>

                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '1rem',
                            padding: '0.75rem 1.5rem',
                            background: '#2563eb',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.375rem',
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        Reload Application
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
